import { SvgIcon, SvgIconProps } from '@mui/material';

export default function Microsoft(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      role="img"
      viewBox="75 75 362 362"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M75 75v171h171v-171z" fill="#f25022" />
      <path d="M266 75v171h171v-171z" fill="#7fba00" />
      <path d="M75 266v171h171v-171z" fill="#00a4ef" />
      <path d="M266 266v171h171v-171z" fill="#ffb900" />
    </SvgIcon>
  );
}
